export const SET_LABELER_ID = "members/SET_LABELER_ID";
export const SET_REVIEWER_ID = "members/SET_REVIEWER_ID";
export const FETCH_USER_IN_PROJECT = "members/FETCH_USER_IN_PROJECT";
export const FETCH_USER_IN_PROJECT_SUCCESS =
  "members/FETCH_USER_IN_PROJECT_SUCCESS";
